// extracted by mini-css-extract-plugin
module.exports = {"badgeImg":"_1EBx47OKXMPQKuwndp4oea"};